export default class chooseInvoiceNoCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal, $state, globalFn) {
        $scope.items = items1

        $scope.invoiceSN = 0


        function isZS(argument) { // 是否正浮点数；
            const reg = /^[0-9]*$/
            return reg.test(argument)
        }

        $scope.ok = function () {
            if ($scope.invoiceSN == 0) {
                if (!isZS($scope.zdyinvoiceSN) || $scope.zdyinvoiceSN < 1) {
                    logger.logError('请输入正整数,位数不能超过3位')
                    return
                }
            }
            if ($scope.items.status == 1) {
                if ($scope.invoiceSN == 0) {
                    $scope.invoiceSN = $scope.zdyinvoiceSN
                }

                for (var a in $scope.items.lIsSlected) {
                    $scope.items.lIsSlected[a].invoiceSN = $scope.invoiceSN
                    $scope.items.lIsSlected[a].billDetailIdList = [$scope.items.lIsSlected[a].billDetailId]
                    $scope.items.lIsSlected[a].selected = false
                    $scope.items.lIsSlected[a].flag = 1
                }
                console.log($scope.items.lIsSlected)
                $uibModalInstance.close($scope.items.lIsSlected)
                // $scope.items.invoiceList = $scope.items.invoiceList.concat($scope.items.lIsSlected)
            } else {
                const merge = {
                    billId: $scope.items.lIsSlected[0].billId,
                    matName: $scope.items.lIsSlected[0].matName, // 商品名称
                    billDetailId: '',
                    billDetailIdList: [], // 明细id列表
                    spec: $scope.items.lIsSlected[0].spec, // 规格型号
                    quantity: '0', // 数量
                    amount: '0', // 金额
                    taxAmount: '0', // 税额
                    invoiceSN: 0, // 发票序号 invoiceSN
                    taxRate: $scope.items.lIsSlected[0].taxRate,
                    unit: $scope.items.lIsSlected[0].unit,
                    flag: 2,
                }
                if ($scope.invoiceSN == 0) {
                    $scope.invoiceSN = $scope.zdyinvoiceSN
                }

                for (var a in $scope.items.lIsSlected) {
                    merge.quantity = globalFn.Add($scope.items.lIsSlected[a].quantity, merge.quantity)
                    merge.amount = globalFn.Add($scope.items.lIsSlected[a].amount, merge.amount)
                    merge.taxAmount = globalFn.Add($scope.items.lIsSlected[a].taxAmount, merge.taxAmount)
                    merge.billDetailIdList.push($scope.items.lIsSlected[a].billDetailId)
                    console.log(merge.billDetailIdList)
                }
                merge.invoiceSN = $scope.invoiceSN
                console.log(merge)
                // $scope.items.invoiceList.push(merge)
                $uibModalInstance.close(merge)
            }
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/chooseInvoiceNoCtrl.js